import axios from 'axios';
import store from '../store';
import { showToast } from '../utils/toast';
// 创建axios实例的工厂函数
const createService = (baseURL) => {
  const service = axios.create({
    baseURL: baseURL,
    timeout: 20000,
  });

  // 请求拦截器
  service.interceptors.request.use(
    (config) => {
      const token = store.state.userInfo?.token;
        if (token) {
          // 添加token到请求头
          // config.headers['token'] = token;
          // 如果需要Bearer格式，可以使用：
          config.headers['Authorization'] = `Bearer ${token}`;
        }
      // 可在此处添加token等公共请求头
       // 我们可以通过baseURL来判断是否需要添加token
      // 根据文件中的定义，userService是需要token的服务
      // const userApiBaseUrl = process.env.VUE_APP_USER_API;
      
      // // 如果当前请求是userService的请求，添加token
      // if (service.defaults.baseURL === userApiBaseUrl || !userApiBaseUrl) {
      //   // 从store中获取token
      //   const token = store.state.userInfo?.token;
      //   if (token) {
      //     // 添加token到请求头
      //     // config.headers['token'] = token;
      //     // 如果需要Bearer格式，可以使用：
      //     config.headers['Authorization'] = `Bearer ${token}`;
      //   }
      // }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // 响应拦截器
  service.interceptors.response.use(
    (response) => {
      return response.data;
    },
    (error) => {
      // 超时提示
      const isTimeout =
        error.code === 'ECONNABORTED' ||
        (error.message && error.message.toLowerCase().includes('timeout'));
      if (isTimeout) {
        showToast('请求超时，请稍后重试', 2000, 'error');
      }
      console.error('API Error:', error);
      return Promise.reject(error);
    }
  );

  return service;
};

// 先算出最终的 user 接口域名
const getUserBaseUrl = () => {
  if (process.env.VUE_APP_IS_CY === 'true') {
    return process.env.VUE_APP_USER_API;
  }
  return process.env.VUE_APP_USER_API_WG;
};

// 三个服务的axios实例
export const authService = createService(
  getUserBaseUrl()
);
// 这里用我们算好的 baseURL
export const userService = createService(getUserBaseUrl());
// export const userService = createService(process.env.VUE_APP_USER_API);

// 封装请求方法
export const authGet = (url, params) => authService.get(url, { params });
export const authPost = (url, data) => authService.post(url, data);

export const userGet = (url, params) => userService.get(url, { params });
export const userPost = (url, data) => userService.post(url, data);
// export const userPost2 = (url, params) => userService.post(url, params)


